module.exports = __webpack_public_path__ + "static/img/J_tiles.10c74b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/J_tiles.svg
// module id = HIFB
// module chunks = 1